// 관리자 웹 신원(계약 §1·§2): 직원 토큰과 내 정보를 sessionStorage 에 둔다(localStorage 금지, 12시간 토큰).
// 토큰이 죽으면(401·사용 중지) v6Api 가 clearAuth 뒤 AUTH_EVENT 를 쏘고, Admin.js 가 로그인 화면으로 돌린다.
export const TOKEN_KEY = "staff_token";
export const ME_KEY = "staff_me";
export const AUTH_EVENT = "admin-auth";

const read = (k) => { try { return sessionStorage.getItem(k); } catch { return null; } };
const write = (k, v) => { try { v === null ? sessionStorage.removeItem(k) : sessionStorage.setItem(k, v); } catch { /* 저장 못 하면 다음 요청이 401 로 알려 준다 */ } };

export const getToken = () => read(TOKEN_KEY);
export function getMe() {
    const raw = read(ME_KEY);
    if (!raw) return null;
    try { return JSON.parse(raw); } catch { return null; }
}
export const saveMe = (me) => write(ME_KEY, JSON.stringify(me));
export function saveLogin(out) {
    write(TOKEN_KEY, out.access_token);
    saveMe(out.user);
}
export function clearAuth() { write(TOKEN_KEY, null); write(ME_KEY, null); }

export const isOwner = (me = getMe()) => me?.role === "owner";

// 계약 §2 menus 열쇠 → 이 앱의 view 값(Admin.js·Sidebar 가 쓰는 예전 이름)
export const MENU_VIEW = { dash: "dashboard", notice: "notice", kb: "knowledge", model: "assistant", report: "chart", ops: "chatbot", inq: "inquiry", chat: "chat_history" };
export const allowedViews = (me) => (me?.menus || []).map((k) => MENU_VIEW[k]).filter(Boolean);

// 비밀번호 규칙(시안 pwOk): 8자 이상, 숫자 하나 이상, 글자(영문 또는 한글) 하나 이상
export const pwOk = (p) => typeof p === "string" && p.length >= 8 && /\d/.test(p) && /[a-zA-Z가-힣]/.test(p);

export const emitAuth = (reason) => window.dispatchEvent(new CustomEvent(AUTH_EVENT, { detail: { reason } }));
